@if (title) {
<h2 mat-dialog-title>
  {{title}}
</h2>
}
<mat-dialog-content>
  <span class="confirmation-message">{{text}}</span>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (showCancelButton) {
  <button mat-stroked-button [matDialogClose]="result">{{cancelButtonText}}</button>
  }
  <button #okayBtn mat-flat-button color="primary" (click)="okay()">{{ okButtonText }}</button>
</mat-dialog-actions>
